import { property } from "underscore";

export const settings = {
  languages: [
    { label: "English", value: "en" }
  ],
  categoriesMapping: {
    // 1028: {name: "explore", displayName: "Things To Do"},
    // 1032: {name: "stay", displayName: "Places To Stay"},
    // 1027: {name: "dine", displayName: "Dining"},
    // 1033: {name: "shop", displayName: "Shopping"},
    // 1034: {name: "explore", displayName: "Outdoors"},
  },

  site: {
    name: 'Big Mountain Lodge',
    address: '15 North State Street, Ferron, UT 84523, United States',
    phone: '(435) 384-3333',
    map: 'https://maps.app.goo.gl/25t6T3S67cRJwdSY9',
    latitude: 33.5039206,
    longitude: -111.9290636,
    website:'https://www.bigmountainlodgeutah.com/',
    privacyLink:'https://www.visitpensacola.com/privacy-policy/',
    twitter:'',
    facebook: 'https://www.facebook.com/bigmountainutah',
    youtube:'https://www.youtube.com/channel/UCV3mkEwIF4XlbzlGoGZIesQ',
    instagram:'https://www.instagram.com/trueomni/',
    pinterest:'https://www.pinterest.com.mx/BigMountainLodge/',
    splashImage: '../themes/BigMountainLodge/assets/splashscreens/bg_img.png',
    homeEvents: false,
    featuredEvents: false,
    socialWallHashtag: ''
  },
  labelCategories: 'Categories',
  displaySocial: true,
  connectWithUsLogoWider: false,
  differentPlaceholders: false,
  organizations: [
    {
      logo: '',
      website: 'https://www.trueomni.com/',
      phone: '+415-974-6900',
      location: 'https://maps.app.goo.gl/25t6T3S67cRJwdSY9',
      latitude: 33.5039206,
      longitude: -111.9290636,
      address: '7014 East Camelback Road Suite B100A, Scottsdale, AZ 85251, United States',
    }
  ],
  eventsCategorysAllowed: [
    
  ],
  regionsData: [],
  hasRegions: false,
  hasSocialWall: false,
  defaultRegion: null,
  hasEventsData: false,
  hasEventsDates: false,
  filterEventsByCategories: false,
  filterEventsByRegion: false,
  filterEventsByfeature: false,
  filterListingsByfeature: false,
  debug: true,
  homeOptions: {
    enabled: false,
    optionPageId: 0,
    fullWithFirstItemMenu: false,
    gridDistribution: [2,2]
  },
  showGradient: false,
  themeColors:{
    headerColor: 'secondary',
    tabsColor: 'primary',
    focusedTabColor: 'secondary'
  },
  socialLogins: {
    facebook: true,
    google: true,
    apple: true
  },
  regionsInteractive: false,
  regions:{
    showInBanner: false
  },
  displayLogoEvents: true,
  versionNumber: "1.12", // use to update cached codes
  hasIAAvatar: false,
  noData: true,
  showSplash: false,
  demoMode: false,
  nexi: {
    useCode: true,
    useCloudbedsAPI: true,
    checkTime: true,
    simulateCheckIn: false,
    simulatePayment: false,
    simulateUpload: false,
    loginOptional: true,
    propertyId: 27672
  },
  manualUpgrades: {
      roomIds: '168283-0|168285-0|168283-1',
      // roomIds: '168283-0|168285-0|168283-1|649316-0|168284-0',
      productId: '196412', // PETFEE
      productName: 'Bring Your Pet',
      productTitle: 'Would you like to bring your Pet to your stay for a $35 fee?',
      productFee: 35.00,
      noButton: 'No, Thank You',
      yesButton: 'Yes, Add My Pet'
  }

};
